export enum AllocationViewProfilesEndpoint {
  ViewProfiles = '/dy/monitoring/profile/view',
  ViewProfilesAll = '/dy/monitoring/profile/view/all',
  ViewProfileDefault = '/dy/monitoring/profile/view/default',
  FilterProfiles = '/dy/monitoring/profile/filter',
  FilterProfilesAll = '/dy/monitoring/profile/filter/all',
  FilterProfileDefault = '/dy/monitoring/profile/filter/default',
  DriverView = '/driver-view',
  Profile = '/profile',
  AllocationPublic = '/allocation/public',
}
